import { computed, type ComputedRef } from "vue";

export interface UseMediaContainerProps {
  width?: string | ComputedRef<string | undefined>;
  height?: string | ComputedRef<string | undefined>;
  objectFit: ComputedRef<"cover" | "contain">;
  aspectRatio: ComputedRef<number>; // aspectRatio медиа (картинки/видео)
  maskProps?: {
    align?: string;
    maskAspectRatio?: number; // aspectRatio маски
    enabled?: boolean;
  };
  hasMask?: ComputedRef<boolean>;
}

/**
 * УПРОЩЕННАЯ ЛОГИКА MEDIACARD
 * 
 * Контейнер для cover и contain одинаковый:
 * - width: 100%, height: 100%, aspect-ratio: (из ContainerSelectInline)
 * 
 * Маска просто вписывается в этот контейнер
 */

export function useMediaContainer(props: UseMediaContainerProps) {
  // ============================================
  // КЛЮЧЕВЫЕ ПЕРЕМЕННЫЕ
  // ============================================
  
  const objectFit = computed<"cover" | "contain">(() => props.objectFit.value);
  const contentAspectRatio = computed(() => props.aspectRatio.value);
  const maskAspectRatio = computed(() => props.maskProps?.maskAspectRatio);
  const maskEnabled = computed(() => 
    (props.maskProps?.enabled ?? props.hasMask?.value ?? false) && !!maskAspectRatio.value
  );

  // Вычисляемые значения для удобства
  const isContain = computed(() => objectFit.value === "contain");
  const isCover = computed(() => objectFit.value === "cover");
  const hasMask = computed(() => maskEnabled.value);
  const hasNoMask = computed(() => !maskEnabled.value);

  return {
    // Ключевые переменные (передаются в layer компоненты для расчета стилей)
    objectFit,
    maskEnabled,
    contentAspectRatio,
    maskAspectRatio,
    isContain,
    isCover,
    hasMask,
    hasNoMask,
  };
}

